import { OnChangePlugin as LexicalOnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';
import { $getRoot, ParagraphNode } from 'lexical';
import { BadgeNode } from '@/Domain/components/Action/Lexical/node/BadgeNode';

type Props = {
  onChange: (val: string) => void;
};

export const OnChangePlugin = ({ onChange }: Props) => (
  <LexicalOnChangePlugin
    onChange={(editorState) => {
      editorState.read(() => {
        const root = $getRoot();
        const serialized: string[] = [];
        const currentParamIds = new Set<number>();

        for (const paragraph of root.getChildren()) {
          if (paragraph.getType() !== 'paragraph') continue;

          for (const node of (paragraph as ParagraphNode).getChildren()) {
            if (node.getType() === 'badge') {
              const badge = node as BadgeNode;
              serialized.push(badge.getLabel());
              if (badge.__parameterId) currentParamIds.add(badge.__parameterId);
            } else {
              serialized.push(node.getTextContent());
            }
          }
        }

        onChange(serialized.join(''));
      });
    }}
  />
);
